module.exports = __webpack_public_path__ + "media/bootstrap-icons/signpost-split-fill-20225e41.svg";